import React from "react";
import { Navigate } from "react-router-dom";
import { useProfile } from "../Components/Hooks/UserHooks";

const PublicRoute = ({ children }) => {
  const { token } = useProfile();
  const authUser = JSON.parse(sessionStorage.getItem("authUser"));
console.log('handleLogout authUser', authUser);

  // While checking auth, don't redirect yet
//   if (loading) return null;

  // ✅ If user is already logged in, block login page
  if (authUser && token) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PublicRoute;